module.exports = __webpack_public_path__ + "static/media/graphicView.6babd02d.png";